export class Timer {
    future: Date = new Date();
    timeInText : String;
    time :Date = new Date();
    timerColour: string;
    pause : boolean = false;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/timer.ts